import React from 'react';

interface BgisButtonIconProps {
  title?:string;
  iconName: string;
  onClick : React.MouseEventHandler<HTMLButtonElement>;
}

export const BgisButtonIcon: React.FC<BgisButtonIconProps> = ({iconName: className, onClick, title} ) => {

  return (<button className="bgis-icon" onClick={onClick} title={title}>
    <i className={className}></i>
  </button>);
   
};

